function InternalError() {
  return (
    <div className="flex h-[calc(100vh-5.7rem)] w-full flex-col items-center justify-center">
      <h2 className="text-gray500 mb-4 text-[3rem] font-black">Erro 500</h2>
      <p className="text-gray200 mb-8 text-center text-[1.15rem]">
        Estamos passando por algumas instabilidades, pedimos desculpas pelo
        transtorno.
        <br />
        Tente novamente mais tarde
      </p>
    </div>
  );
}

export default InternalError;
